import React, { useState, useEffect } from 'react'
import VipImg from '@img/vip.png'
import SingleImg from '@img/single.png'
import { keyBy } from '@dt/fe-utils/dist/lodash'

interface IProps {
  offItems: any[];
}

interface IObj {
  [key: string]: string;
}

const DiscountTag: React.FC<IProps> = props => {
  const { offItems = [] } = props
  // useEffect(() => {
  //   offItems
  // })
  const offObj = keyBy(offItems, 'offType')
  const offArr = Object.keys(offObj)
  return (
    <>
      {
        offArr.includes('coupon') ? <div className='single' style={{ background: `url(${SingleImg})`, padding: '0 2px' }}><span>{i18n.t('cart.singleCoupon')}</span></div> : <></>
      }
      {
        offArr.includes('memberPrice') ? <div><img src={VipImg} alt='' /></div> : <></>
      }
    </>
  )
}

export default DiscountTag
